import React from "react";

export default function LaborDayFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-lab11{fill:#2c3333}.cls-lab13{fill:#2e4f4f}"}</style>
        </defs>
        <path
          d="M404.62 491.86c-1.98-1.33-44.03-28.68-77.05-7.59-21.39 13.66-30.74 42.39-24.42 74.92-32-48.23-64-96.45-96-144.68 15.4-1.75 38.59-6.79 61.29-22.55 20.5-14.23 32.93-31.87 40.18-44.78 32 48.23 64 96.45 96 144.68Z"
          className="cls-lab11"
        />
        <path
          d="m497.26 430.39-92.64 61.47-96-144.68 92.64-61.47c34.41-19.14 84.26-39.82 145.55-41.54 38.46-1.08 73.09 5.54 73.04 9.48-.05 4.45-44.31.97-99.89 20.8-22.84 8.15-76.67 27.36-79.37 58.41-.5 5.76.8 11.44 21.51 44.54 14.11 22.55 26.48 40.65 35.16 52.99Z"
          className="cls-lab11"
        />
        <path
          d="M733.39 809.78c-27.96 13.39-54.21 30.36-77.9 50.57l-9.57-4.83-89.85-135.4-138.41-208.59-1.52-2.29-11.53-17.38 6.07-4.03 86.07-57.11 12.82 19.33 137.91 207.83 85.84 129.37.07 22.53Z"
          style={{
            fill: "#202626",
          }}
        />
        <rect
          width={42.36}
          height={188.25}
          x={223.67}
          y={399.55}
          className="cls-lab13"
          rx={10.78}
          ry={10.78}
          transform="rotate(-33.57 244.805 493.64)"
        />
        <rect
          width={117.35}
          height={26.08}
          x={398.02}
          y={457.93}
          className="cls-lab13"
          rx={7.01}
          ry={7.01}
          transform="rotate(-33.57 456.628 470.925)"
        />
        <rect
          width={11}
          height={196}
          x={358.11}
          y={328.86}
          className="cls-lab13"
          rx={5.5}
          ry={5.5}
          transform="rotate(-33.57 363.555 426.828)"
        />
        <path
          d="m1738.14 781.42 81.85-41.97c1.76 15.01.18 30.65-5.26 45.84-18.84 52.69-76.83 80.14-129.52 61.29-52.69-18.84-80.14-76.83-61.29-129.52 18.84-52.69 76.83-80.14 129.52-61.29 13.65 4.88 25.61 12.39 35.5 21.75l-82.42 42.26c-3.71 14.76-7.42 29.52-11.14 44.29 14.25 5.78 28.5 11.57 42.75 17.36Z"
          className="cls-lab11"
        />
        <path
          d="m1245.576 940.573 380.04-194.895 43.432 84.693-380.04 194.895c-12.724 6.525-28.353 1.492-34.878-11.232l-19.786-38.582c-6.526-12.725-1.493-28.353 11.232-34.879Z"
          className="cls-lab11"
        />
        <path
          d="m1547.933 785.514 20.741-10.636 43.433 84.692-20.741 10.637z"
          className="cls-lab13"
        />
        <path
          d="m328.95 1588.49-60.02 53.76c-4.83-12.33-6.96-25.92-5.74-40.01 4.25-48.83 47.27-84.97 96.11-80.73 48.83 4.25 84.97 47.27 80.73 96.11-4.25 48.83-47.27 84.97-96.11 80.73-12.65-1.1-24.45-4.8-34.91-10.53l60.43-54.13c-.14-13.33-.27-26.66-.41-40-13.36-1.73-26.72-3.47-40.07-5.2Z"
          className="cls-lab11"
        />
        <path
          d="m642.75 1391.12-6.73 20.01-112.97 101.18-33.89 30.36-15.21 13.63-36.15 32.38-5.6 5.01-55.62-62.1 5.59-5.01 36.16-32.38 15.2-13.63 35.31-31.62 126.2-113.04c13.91 19.9 29.88 38.45 47.71 55.21Z"
          className="cls-lab11"
        />
        <path
          d="m489.198 1542.63-15.211 13.624-55.623-62.102 15.21-13.624z"
          className="cls-lab13"
        />
        <path
          d="M1417.32 1292.1c1.08-3.39 2.1-6.82 3.03-10.24 8.21-27.83 13.97-55.81 17.39-83.79a483.46 483.46 0 0 0 2.91-29.38l87.5-35.95c.09-42.54-4.18-84.54-12.54-125.54l-91.44-12.79c-12-45.53-29.92-89.17-53.1-129.84l53.8-76.95a628.421 628.421 0 0 0-76.69-94.88l-84.05 38.74a537.937 537.937 0 0 0-121.16-82.36l3.61-93.04a631.066 631.066 0 0 0-56.59-20.69 619.705 619.705 0 0 0-58.31-15.18l-50.06 78.43c-49.35-7.24-98.58-7.51-146.48-1.37l-46.98-79.71c-40.2 7.58-79.39 19.09-117.05 34.18l.31 93.94a538.22 538.22 0 0 0-23.94 12.2c-32.44 17.53-63.11 38.36-91.41 62.24-.76.64-1.52 1.28-2.28 1.93l-82.44-41.57a621.663 621.663 0 0 0-81.83 95.99l51.35 79.41c-13.07 22.01-24.66 45.17-34.67 69.38a549.193 549.193 0 0 0-16.47 45.37c-.43 1.37-.84 2.84-1.22 4.25l-60.31 6.35-31.58 3.28c-10.58 43.51-16.37 87.17-17.48 130.42l86.43 39.16c1.68 40.05 7.82 79.46 18.19 117.57l-72.37 57.94a626.308 626.308 0 0 0 57.29 124.04l93.63-13.83c2.14 3.07 4.31 6.11 6.53 9.14a531.163 531.163 0 0 0 54.21 63.36c3.76 3.78 7.6 7.5 11.5 11.17l-29.8 88.58c35.42 29.44 74.41 55.11 116.61 76.43l70.96-61.9c16.34 6.92 33.16 13.16 50.46 18.53 17.3 5.45 34.68 9.92 52.06 13.5l23.01 91.34c46.8 6.53 93.52 7.63 139.35 3.7l26.01-89.77c36.73-5.52 72.59-14.86 107.05-27.59l69.03 64.7c41.64-18.73 81.19-41.91 117.79-69.22l-26.38-88.87a537.006 537.006 0 0 0 81.97-86.28l93.26 17.15c23.76-36.21 43.89-75.42 60.03-117.18l-70.03-60.21c.46-1.43.93-2.86 1.39-4.29Zm-174.49-135.95c-.44 6.47-1.08 12.96-1.92 19.46a344.111 344.111 0 0 1-11.52 55.49c-.61 2.26-1.3 4.53-2.01 6.79-.31.94-.61 1.89-.92 2.84l46.38 39.87c-10.69 27.66-24.03 53.62-39.76 77.61l-61.77-11.36a354.814 354.814 0 0 1-54.28 57.14l17.47 58.86c-24.23 18.08-50.43 33.43-78 45.84l-45.72-42.85c-22.83 8.44-46.58 14.61-70.89 18.27l-17.24 59.45a411.743 411.743 0 0 1-92.28-2.45l-15.25-60.49a349.46 349.46 0 0 1-34.47-8.94c-11.45-3.55-22.6-7.69-33.42-12.27l-47 40.99c-27.93-14.12-53.77-31.12-77.22-50.62l13.01-38.65 6.73-20.01c-17.83-16.76-33.8-35.31-47.71-55.21l-.14-.2-62.01 9.16a416.258 416.258 0 0 1-37.94-82.14l47.92-38.38a353.078 353.078 0 0 1-12.03-77.87l-57.24-25.93c.73-28.65 4.57-57.56 11.57-86.37l20.92-2.18 39.94-4.2c.25-.94.52-1.91.8-2.82 3.23-10.26 6.87-20.28 10.92-30.05 6.63-16.02 14.29-31.37 22.96-45.94L546.7 896.4a411.937 411.937 0 0 1 54.19-63.58l45.03 22.7 9.57 4.83c23.69-20.21 49.94-37.18 77.9-50.57l-.07-22.53-.13-39.69c24.94-9.99 50.89-17.62 77.52-22.63l31.11 52.78c31.72-4.06 64.33-3.88 97.01.91l33.16-51.94c12.92 2.7 25.79 6.05 38.61 10.05 12.82 4.01 25.34 8.6 37.48 13.7l-2.39 61.63a356.327 356.327 0 0 1 80.24 54.54l55.66-25.66c19.01 19.33 36 40.38 50.8 62.84l-35.64 50.96c15.35 26.94 27.23 55.83 35.18 85.99l60.54 8.47c5.54 27.16 8.38 54.97 8.3 83.14l-57.94 23.81Z"
          style={{
            fill: "#0e8388",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
